import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import PreviewCard from "./PreviewCard";
import Pagination from "./Pagination";

const BranchPreview = ({ branches, onRemove, onEdit }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const branchesPerPage = 4;
  const totalPages = Math.ceil(branches.length / branchesPerPage);

  const getCurrentPageBranches = () => {
    const startIndex = (currentPage - 1) * branchesPerPage;
    const endIndex = startIndex + branchesPerPage;
    return branches.slice(startIndex, endIndex);
  };

  return (
    <div className="space-y-4">
      <motion.div layout className="flex flex-col gap-3">
        <AnimatePresence mode="popLayout">
          {getCurrentPageBranches().map((branch) => (
            <PreviewCard
              key={branch.id}
              branch={branch}
              onRemove={onRemove}
              onEdit={onEdit}
            />
          ))}
        </AnimatePresence>
      </motion.div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

export default BranchPreview;
